import { Reveal } from "./Reveal";
import { CLINIC, IMAGES } from "../lib/content";
import { Award, HeartHandshake, ShieldCheck } from "lucide-react";

const stats = [
  { k: "25 yrs", v: "Clinical practice" },
  { k: "MRCOG", v: "London (UK)" },
  { k: "MRCPI", v: "Ireland" },
];

const highlights = [
  { icon: Award, t: "Dual international accreditation", d: "Member of the Royal Colleges of Obstetricians & Gynaecologists (London) and Physicians of Ireland." },
  { icon: HeartHandshake, t: "Fertility & aesthetic gynaecology", d: "Sub-specialty focus in reproductive medicine and aesthetic gynaecology, alongside full-scope OBG care." },
  { icon: ShieldCheck, t: "Evidence-led, plain-spoken care", d: "Twenty-five years at the bedside — explaining the ‘why’, not just the ‘what’ of every decision." },
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="overflow-hidden rounded-[1.5rem] border border-border" style={{ aspectRatio: "5/6" }}>
                <img src={IMAGES.clinic} alt="Mom and More Clinic interior" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -top-6 -right-4 hidden sm:block bg-accent text-accent-foreground rounded-2xl px-5 py-4 max-w-[10rem]">
                <p className="font-serif text-2xl leading-none">Mom &amp; More</p>
                <p className="text-[0.7rem] mt-2 opacity-90">A calm space for every woman.</p>
              </div>
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <span className="overline text-accent">About the doctor</span>
              <h2 className="font-serif text-primary text-4xl sm:text-5xl tracking-tight leading-[1.02] mt-5">
                Meet {CLINIC.doctor}
              </h2>
              <p className="mt-6 text-muted-foreground text-base sm:text-lg leading-relaxed">
                {CLINIC.mediumBio}
              </p>
              <p className="mt-4 text-sm text-foreground/80 italic">
                {CLINIC.affiliations}.
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-9 grid gap-5">
                {highlights.map((h) => (
                  <div key={h.t} className="flex gap-4 items-start p-4 rounded-xl border border-border hover:-translate-y-0.5 transition-transform duration-300 bg-card">
                    <div className="shrink-0 w-11 h-11 rounded-lg bg-secondary/50 flex items-center justify-center text-primary">
                      <h.icon size={20} />
                    </div>
                    <div>
                      <p className="font-semibold text-foreground">{h.t}</p>
                      <p className="text-sm text-muted-foreground mt-0.5">{h.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-10 grid grid-cols-3 gap-4 border-t border-border pt-8">
                {stats.map((s) => (
                  <div key={s.v}>
                    <p className="font-serif text-primary text-3xl sm:text-4xl">{s.k}</p>
                    <p className="text-xs sm:text-sm text-muted-foreground mt-1">{s.v}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
